import React from "react";
import { useTranslation } from "react-i18next";

const PysicalActiveManagement = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <Swiper spaceBetween={2} slidesPerView={1}>
        <SwiperSlide>
          <div className="w-full h-[220px] bg-gray-100 flex justify-center items-center">
            image
          </div>
        </SwiperSlide>
      </Swiper> */}

      <div className="w-full pt-[16px] wordbreak-keepall body_1_400_jangrucont">
        <div className="flex ">
          <span className="inline-block">•&nbsp;</span>
          <div>
            <span className="inline-block">
              {t('PysicalActiveManagement_carry_products', '간단한 외출이더라도 장루 제품은 꼭 하나씩 휴대하고 다니세요.')}
            </span>
          </div>
        </div>
        <div className="flex ">
          <span className="inline-block">•&nbsp;</span>
          <div>{t('PysicalActiveManagement_return_timing', '업무로 복귀하는 시점은 개인의 회복 수준에 따라 달라집니다.')}</div>
        </div>
        <div className="flex ">
          <span className="inline-block">•&nbsp;</span>
          <div>
            {t('PysicalActiveManagement_work_return', '무거운 물건을 반복해서 들어올리는 일 이외에는 일상적인 직장으로 복귀가 가능합니다.')}
          </div>
        </div>
        <div className="flex pt-[32px]">
          <span className="inline-block">•&nbsp;</span>
          <div>{t('PysicalActiveManagement_social_tips', '사회활동 시 장루에 관한 몇가지 팁')}</div>
        </div>
        <div className="flex">
          <span className="inline-block">-&nbsp;</span>
          <div>
            {t('PysicalActiveManagement_prepare_supplies', '대변 누출, 주머니 교체가 필요할 시를 대비하여 물품을 보관해 놓고 여분의 옷도 준비하세요.')}
          </div>
        </div>
        <div className="flex">
          <span className="inline-block">-&nbsp;</span>
          <div>
            {t('PysicalActiveManagement_find_restroom', '장루주머니 관리를 위한 최적의 화장실이나 장소를 찾고 냄새제거제 등의 사용을 하여 냄새를 줄이도록 합니다.')}
          </div>
        </div>
        <div className="flex">
          <span className="inline-block">-&nbsp;</span>
          <div>
            {t('PysicalActiveManagement_clothing_tips', '오래 앉아 있는 일의 경우 느슨한 옷을 입고, 활동적인 일을 할 경우에는 장루용 벨트를 착용합니다.')}
          </div>
        </div>
        <div className="flex">
          <span className="inline-block">-&nbsp;</span>
          <div>{t('PysicalActiveManagement_noise', '장루에서 나는 소음에 너무 신경쓰지 않아도 됩니다.')}</div>
        </div>
        <div className="flex">
          <span className="inline-block">-&nbsp;</span>
          <div>{t('PysicalActiveManagement_hydration', '수분을 적절히 섭취하세요.')}</div>
        </div>
        <div className="flex">
          <span className="inline-block">-&nbsp;</span>
          <div>
            {t('PysicalActiveManagement_support_group', '장루에 대한 협회와 연관된 지지모임을 알아보고 조언과 정보를 구하면 좋습니다.')}
          </div>
        </div>
      </div>
      <div className="h-[80px]"></div>
    </>
  );
};

export default PysicalActiveManagement;
